import classNames from "classnames/bind";
import React from "react";

import { useIsArcade } from "@/hooks/useIsArcade";

import { LocationProps, LatLngLiteralProps } from "../../interfaces/locations/location-interface";
import { InStoreInfoWindow } from "./in-store-infowindow";
import { InStoreTile } from "./in-store-tile";
import styles from "./instore.module.scss";

const cx = classNames.bind(styles);

export interface MarkerProps {
    location: LocationProps;
    onClick?: (location: LocationProps) => void;
    activeLocation: {
        isActive: boolean;
        location: LocationProps;
    };
    previousLocation: {
        isActive: boolean;
        location: LocationProps;
    };
}

type Props = MarkerProps & LatLngLiteralProps;

export const InStoreMarker: React.FC<Props> = (props: Props) => {
    const { activeLocation, previousLocation, location, onClick } = props;
    const isArcade = useIsArcade();

    const inStoreMarkerClassName = cx({
        [styles.inStoreMarker]: true,
        [styles.arcade]: isArcade,
    });

    return (
        <div className={styles.inStoreMarkerContainer} onClick={() => onClick(location)}>
            {activeLocation.isActive &&
                !previousLocation.isActive &&
                activeLocation.location.id === location.id && (
                    <InStoreInfoWindow location={location} />
                )}
            <div className={inStoreMarkerClassName} />
        </div>
    );
};
